import {withJsonFormsControlProps} from '@jsonforms/react'
import component from './ReadOnlyFieldWithJson'
export default withJsonFormsControlProps(component)
